import { render, staticRenderFns } from "./AddChild.vue?vue&type=template&id=014e4dfd"
import script from "./AddChild.vue?vue&type=script&lang=js"
export * from "./AddChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports